import React from "react";
import "./HeroSection.css";

export default function HeroSection() {
  return (
    <div className="hero-section-container">
      {/* Left التركواز Content with text animations */}
      <div className="left-hero-panel">
        <div className="animated-intro">
          <p className="animated-line">مصمم عناية يساعدك مهتم بتقديم نصائح خطوة بخطوة</p>
          <p className="animated-line">ومحتوى مفيد لكل من المبتدئين وأيضًا لمن لديهم خبرة.</p>
          <p className="animated-line">هدفي أن أنقل لك أفضل ما تعلمته وأن أكون شريك نجاح</p>
          <p className="animated-line">في بناء مهاراتك.</p>
        </div>
      </div>

      {/* Right الأسود Content with navigation and image animations */}
   

        {/* Main Photo with animation */}
        <img
          src="/images/About.png"
          alt="صورة مصمم عناية"
          className="hero-main-photo-animated"
        />
      </div>
  );
}